module.exports = __webpack_public_path__ + "img/walk-3b06686.jpg";